/**
 * 模块名称: 业务配置管理
 * @author zhuyan@372163.com
 */

import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ProjectMgt from './ProjectMgt'
import ProjectConfig from './ProjectConfig'
import DiscountTable from './DiscountTable'
import SettleConfig from './SettleConfig'
import './assets/style.scss'

const ConfigMsgIndex = ({ match, history }) => {

  return (
    <Switch>
      <Route path={match.path + '/projectMgt'} component={ProjectMgt} />
      <Route path={match.path + '/projectConfig'} component={ProjectConfig} />
      <Route path={match.path + '/discountTable'} component={DiscountTable} />
      <Route path={match.path + '/settleConfig'} component={SettleConfig} />
      <Route component={ProjectMgt} />
    </Switch>
  )
}

export default ConfigMsgIndex